import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import ExpIngredientsComponent from '@app/components/apps/FeedExpectedIngredients/FeedExpIngredient';

export const ViewExpIngredient: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('View Feed Expected Ingredient');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    { path: '/feed-exp-ingredients', breadcrumbName: 'Feed Expected Ingredients' },
    { path: `/view-exp-ingredients/${id}`, breadcrumbName: 'View Feed Expected Ingredient' },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ExpIngredientsComponent
          type={'view'}
          editable={false}
          id={id}
          pageTitle={`View Feed Expected Ingredient`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default ViewExpIngredient;
